<template>
  <div class="v2-steps-create-porn">
    <hr />
    <div class="row m-0">
      <div class="col-lg-6">
        <h2 class="mb-4 mb-lg-0" v-html="t('The Steps to Creating Magical Porn...')" />
        <img v-lazy="toyboybtsImage" class="w-100 d-lg-none rounded-1" :alt="`Create porn poster`" />
        <div class="d-flex flex-wrap">
          <div class="row">
            <div v-for="(priority, i) in priorities" :key="i" class="col-12 col-md-6 priority mt-4 mt-md-6">
              <badge :icon="priority.icon" :theme="priority.theme" class="mb-3 m-auto ms-md-0 me-md-0" />
              <badge-description :description="priority.description" :title="priority.title" />
            </div>
          </div>
        </div>
      </div>
      <lazy-component class="col-lg-6 d-none d-lg-block">
        <div class="cover rounded-1 h-100" />
      </lazy-component>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import BadgeDescription from "@/components/v2/badge-description/index.vue";
import Badge from "@/components/v2/badge/index.vue";
import toyboybtsImage from "@/assets/v2/images/home/toyboybts.jpeg";

defineOptions({
  name: "steps-create-porn",
});

const { t } = useI18n();

const priorities = computed(() => [
  {
    icon: "sparkle",
    title: t("Performer desires"),
    description: t("The BEST thing is we get to make models' fantasies come true!"),
    theme: "peach",
  },
  {
    icon: "film-slate",
    title: t("Filmed by women"),
    description: t("Who better to capture female pleasure than women?"),
    theme: "orange",
  },
  {
    icon: "flower-lotus",
    title: t("Safety & consent first"),
    description: t("if it's not a fuck yes, it's a fuck no. We're not interested in unhappy sex."),
    theme: "light-pink",
  },
  {
    icon: "smile-wink",
    title: t("Authentic sex"),
    description: t("No scripts, no fake orgasms, just real people having lovely sex on film"),
    theme: "light",
  },
]);
</script>

<style lang="scss">
@import "./index.scss";
</style>
